import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';
import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';

export const GetDepartmentList = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.DEPARTMENT_LIST);
  return response;
};

export const AddNewDepartmentData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.DEPARTMENT_LIST,
    data
  );
  return response;
};
export const GetDepartmentDEtailById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEPARTMENT_LIST}/${id}`
  );
  return response;
};
export const UpdateDepartmentDetail = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.DEPARTMENT_LIST}/${id}`,
    {
      data
    }
  );
  return response;
};
export const DeleteDepartmentById = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.DEPARTMENT_LIST}/${id}`
  );
  return response;
};

export const GetDepartmentListByOrganizationId = async (orgId) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEPARTMENT_LIST}/${orgId}`
  );
  return response;
};

export const AssignDeviceToDepartment = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.ASSIGN_DEVICE_DEPARTMENT,
    data
  );
  return response;
};
